// 第一次获取全部的storage，以后的操作都从这个里取，set的时候同时改这个对象
let storageObj = {}

export function getStorage(key) {
  if (storageObj && storageObj[key]) {
    return storageObj[key]
  } else {
    storageObj[key] = wx.getStorageSync(key)
    return storageObj[key]
  }
}

export function getStorageSync(key) {
  storageObj[key] = wx.getStorageSync(key)
  return storageObj[key]
}

export function setStorageSync(key, data) {
  storageObj[key] = data
  wx.setStorageSync(key, data)
}

export function setMapStorageSync(keyMap = {}) {
  for (const key in keyMap) {
    setStorageSync(key, keyMap[key])
  }
}

export function setStorage({ key, data }) {
  storageObj[key] = data
  wx.setStorage({
    key,
    data
  })
}

export function setMapStorage(keyMap) {
  for (const key in keyMap) {
    setStorage({
      key,
      data: keyMap[key]
    })
  }
}

export function setMaxLenStorage({ key, text, maxLen = 5 }) {
  let data = getStorage(key) || []
  const index = data.indexOf(text)
  if (index !== -1) {
    data.splice(index, 1)
  }
  data.unshift(text)
  data && data.length > maxLen && (data = data.slice(0, maxLen))
  setStorage({ key, data })
}

export function removeStorage(key, callbackFun) {
  wx.removeStorage({
    key,
    success(res) {
      // console.log(res)
      callbackFun && callbackFun()
    }
  })
}
